import React, { useEffect, useState } from 'react';
import App from './LaRocaApp';
import MapOverlay from './components/common/MapOverlay';
import Passport from './pages/Passport';
import SelectLanguage from './pages/SelectLanguage';
import MapInstructions from './pages/map/Instructions';
import MapV2 from './pages/map/MapV2';
import MapWelcome from './pages/map/Welcome';
import LaValleApp from './LaValleApp';
import Womenswear from './pages/shops/Womenswear';
import Menswear from './pages/shops/Menswear';
import Sportswear from './pages/shops/Sportswear';
import BagsAndLuggages from './pages/shops/BagsLuggage';
import Shoes from './pages/shops/Shoes';
import Accessories from './pages/shops/Accessories';
import Beauty from './pages/shops/Beauty';
import Homeware from './pages/shops/Homeware';
import FidenzaApp from './FidenzaApp';
import BicesterApp from './BicesterApp';
import Children from './pages/shops/Children';
import Urban from './pages/shops/Urban';
import { disptchCTAClickObject, dispatchStartTagManagerAnalytics } from './Analytics';
import { v4 as uuidv4 } from 'uuid';

// const App = React.lazy(() => import('./App'));

const sessionKey = 'bicestersid';

const LandingPage = () => {
  const [firstVisit, setFirstVisit] = useState(true);
  const [mapActive, setMapActive] = useState(true);
  const [welcomeActive, setWelcomeActive] = useState(false);
  const [instructionsActive, setInstructionsActive] = useState(false);
  const [selectLanguageActive, setSelectLanguageActive] = useState(false);
  const [passportActive, setPassportActive] = useState(false);
  const [showLaRocaApp, setShowLaRocaApp] = useState(false);
  const [showLaValleApp, setShowLaValleApp] = useState(false);
  const [showBicesterApp, setShowBicesterApp] = useState(false);
  const [showFidenzaApp, setShowFidenzaApp] = useState(false);
  const [womenswearActive, setWomenswearActive] = useState(false);
  const [menswearActive, setMenswearActive] = useState(false);
  const [sportswearActive, setSportswearActive] = useState(false);
  const [bagsLugggeActive, setBagsLuggageActive] = useState(false);
  const [shoesActive, setShoesActive] = useState(false);
  const [accessoriesActive, setAccessoriesActive] = useState(false);
  const [homewareActive, setHomewareActive] = useState(false);
  const [childrenActive, setChildrenActive] = useState(false);
  const [urbanActive, setUrbanActive] = useState(false);
  const [beautyActive, setBeautyActive] = useState(false);
  const [villageName, setVillageName] = useState('map');

  const closeMap = (villageName: string) => {
    // window.InitiateExperience();
    if (villageName === 'laroca') {
      dispatchStartTagManagerAnalytics('laroca');
      setShowLaRocaApp(true);
      setShowLaValleApp(false);
      setShowBicesterApp(false);
      setShowFidenzaApp(false);
    } else if (villageName === 'lavallee') {
      dispatchStartTagManagerAnalytics('lavallee');
      setShowLaValleApp(true);
      setShowLaRocaApp(false);
      setShowBicesterApp(false);
      setShowFidenzaApp(false);
    } else if (villageName === 'bicester') {
      dispatchStartTagManagerAnalytics('bicester');
      setShowBicesterApp(true);
      setShowLaValleApp(false);
      setShowLaRocaApp(false);
      setShowFidenzaApp(false);
    } else if (villageName === 'fidenza') {
      dispatchStartTagManagerAnalytics('fidenza');
      setShowFidenzaApp(true);
      setShowBicesterApp(false);
      setShowLaValleApp(false);
      setShowLaRocaApp(false);
    }

    if (firstVisit) {
      setFirstVisit(false);
    }

    setMapActive(false);
    window.changeUrls();
  };

  const onLanguageSelectClose = () => {
    setSelectLanguageActive(false);
    setWelcomeActive(true);
  };

  const onWelcomeClose = () => {
    disptchCTAClickObject(villageName, 'Button', 'WelcomePage', 'Enter', '');
    dispatchStartTagManagerAnalytics('Map');
    setWelcomeActive(false);
    setInstructionsActive(true);
  };

  const toggleMap = (roomAggregator: string) => {
    disptchCTAClickObject(roomAggregator, 'Button', 'ToggleMap', 'Click', '');
    setMapActive(true);
  };

  const openWomenswear = () => {
    disptchCTAClickObject(villageName, 'Button', 'Womenswear', 'Open', '');
    setWomenswearActive(true);
  };

  const closeWomenswear = () => {
    disptchCTAClickObject(villageName, 'Button', 'Womenswear', 'Close', '');
    setWomenswearActive(false);
  };

  const openMenswear = () => {
    disptchCTAClickObject(villageName, 'Button', 'Menswear', 'Open', '');
    setMenswearActive(true);
  };

  const closeMenswear = () => {
    disptchCTAClickObject(villageName, 'Button', 'Menswear', 'Close', '');
    setMenswearActive(false);
  };

  const openSportswear = () => {
    disptchCTAClickObject(villageName, 'Button', 'Sportwear', 'Open', '');
    setSportswearActive(true);
  };

  const closeSportswear = () => {
    disptchCTAClickObject(villageName, 'Button', 'Sportwear', 'Close', '');
    setSportswearActive(false);
  };

  const openBagsLuggage = () => {
    disptchCTAClickObject(villageName, 'Button', 'BagsLuggage', 'Open', '');
    setBagsLuggageActive(true);
  };

  const closeBagsLuggage = () => {
    disptchCTAClickObject(villageName, 'Button', 'BagsLuggage', 'Close', '');
    setBagsLuggageActive(false);
  };

  const openShoes = () => {
    disptchCTAClickObject(villageName, 'Button', 'Shoes', 'Open', '');
    setShoesActive(true);
  };

  const closeShoes = () => {
    disptchCTAClickObject(villageName, 'Button', 'Shoes', 'Close', '');
    setShoesActive(false);
  };

  const openAccessories = () => {
    disptchCTAClickObject(villageName, 'Button', 'Accessories', 'Open', '');
    setAccessoriesActive(true);
  };

  const closeAccessories = () => {
    disptchCTAClickObject(villageName, 'Button', 'Accessories', 'Close', '');
    setAccessoriesActive(false);
  };

  const openHomeware = () => {
    disptchCTAClickObject(villageName, 'Button', 'Homeware', 'Open', '');
    setHomewareActive(true);
  };

  const closeHomeware = () => {
    disptchCTAClickObject(villageName, 'Button', 'Homeware', 'Close', '');
    setHomewareActive(false);
  };

  const openBeauty = () => {
    disptchCTAClickObject(villageName, 'Button', 'Beauty', 'Open', '');
    setBeautyActive(true);
  };

  const closeBeauty = () => {
    disptchCTAClickObject(villageName, 'Button', 'Beauty', 'Close', '');
    setBeautyActive(false);
  };

  const toggleInstructionsAction = (isActive: boolean) => {
    const cta_action: string = isActive ? 'Open' : 'Close';
    setInstructionsActive(isActive);
    disptchCTAClickObject(villageName, 'Button', 'Instructions', cta_action, '');
  };

  const togglePassportAction = (isActive: boolean) => {
    const cta_action: string = isActive ? 'Open' : 'Close';
    setPassportActive(isActive);
    disptchCTAClickObject(villageName, 'Button', 'Passport', cta_action, '');
  };

  const openChildren = () => {
    disptchCTAClickObject(villageName, 'Button', 'Children', 'Open', '');
    setChildrenActive(true);
  };

  const closeChildren = () => {
    disptchCTAClickObject(villageName, 'Button', 'Children', 'Close', '');
    setChildrenActive(false);
  };

  const openUrban = () => {
    disptchCTAClickObject(villageName, 'Button', 'Urban', 'Open', '');
    setUrbanActive(true);
  };

  const closeUrban = () => {
    disptchCTAClickObject(villageName, 'Button', 'Urban', 'Close', '');
    setUrbanActive(false);
  };

  const GotoVillage = (villageName: string) => {
    const villageNameChunks = villageName.split('_');

    if (villageNameChunks[0] === 'lr') {
      setShowLaRocaApp(true);
      setShowLaValleApp(false);
      setShowBicesterApp(false);
      setShowFidenzaApp(false);
    } else if (villageNameChunks[0] === 'lv') {
      setShowLaValleApp(true);
      setShowLaRocaApp(false);
      setShowBicesterApp(false);
      setShowFidenzaApp(false);
    } else if (villageNameChunks[0] === 'bv') {
      setShowBicesterApp(true);
      setShowLaRocaApp(false);
      setShowLaValleApp(false);
      setShowFidenzaApp(false);
    } else if (villageNameChunks[0] === 'fv') {
      setShowFidenzaApp(true);
      setShowLaRocaApp(false);
      setShowLaValleApp(false);
      setShowBicesterApp(false);
    }

    window.GotoScene(villageName);
  };

  useEffect(() => {
    //Generate New Session ID if no session ID is present
    const value = localStorage.getItem(sessionKey);
    // console.log('Value', value);
    if (!value || value === null) {
      const id = uuidv4();
      localStorage.setItem(sessionKey, id);
      // console.log('Generated Value', id);
    }

    window.InitiateExperience && window.InitiateExperience();
    window.toggleMap = toggleMap;
    window.GotoVillage = GotoVillage;
    window.openWomenswear = openWomenswear;
    window.openMenswear = openMenswear;
    window.openSportswear = openSportswear;
    window.openBagsLuggage = openBagsLuggage;
    window.openShoes = openShoes;
    window.openAccessories = openAccessories;
    window.openHomeware = openHomeware;
    window.openBeauty = openBeauty;
    window.openChildren = openChildren;
    window.openUrban = openUrban;
  }, []);

  useEffect(() => {
    if (showLaRocaApp) {
      setVillageName('la_roca');
    }
  }, [showLaRocaApp]);

  useEffect(() => {
    if (showLaValleApp) {
      setVillageName('la_vallee');
    }
  }, [showLaValleApp]);

  useEffect(() => {
    if (showBicesterApp) {
      setVillageName('bicester');
    }
  }, [showBicesterApp]);

  useEffect(() => {
    if (showFidenzaApp) {
      setVillageName('fidenza');
    }
  }, [showFidenzaApp]);

  return (
    <>
      {mapActive ? (
        <>
          <MapOverlay
            firstVisit={firstVisit}
            closeAllUI={() => {
              setInstructionsActive(false);
            }}
            openFirstModal={() => setSelectLanguageActive(true)}
            togglePassport={() => {
              togglePassportAction(!passportActive);
            }}
            toggleInstructions={() => {
              toggleInstructionsAction(!instructionsActive);
            }}
            villageName={villageName}
          />
          <SelectLanguage active={selectLanguageActive} setActive={onLanguageSelectClose} villageName={villageName} />
          <MapV2 setActive={closeMap} villageName={villageName} />
          <MapWelcome active={welcomeActive} setActive={onWelcomeClose} />
          <MapInstructions active={instructionsActive} setActive={() => toggleInstructionsAction(false)} />
          <Passport active={passportActive} setActive={() => togglePassportAction(false)} villageName="none" />
        </>
      ) : (
        <>
          {showLaRocaApp && <App />}
          {showLaValleApp && <LaValleApp />}
          {showBicesterApp && <BicesterApp />}
          {showFidenzaApp && <FidenzaApp />}
          <Womenswear active={womenswearActive} setActive={() => closeWomenswear()} villageName={villageName} />
          <Menswear active={menswearActive} setActive={() => closeMenswear()} villageName={villageName} />
          <Sportswear active={sportswearActive} setActive={() => closeSportswear()} villageName={villageName} />
          <BagsAndLuggages active={bagsLugggeActive} setActive={() => closeBagsLuggage()} villageName={villageName} />
          <Shoes active={shoesActive} setActive={() => closeShoes()} villageName={villageName} />
          <Accessories active={accessoriesActive} setActive={() => closeAccessories()} villageName={villageName} />
          <Homeware active={homewareActive} setActive={() => closeHomeware()} villageName={villageName} />
          <Beauty active={beautyActive} setActive={() => closeBeauty()} villageName={villageName} />
          <Children active={childrenActive} setActive={() => closeChildren()} villageName={villageName} />
          <Urban active={urbanActive} setActive={() => closeUrban()} villageName={villageName} />
        </>
      )}
    </>
  );
};

export default LandingPage;
